import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { IconCheck } from '@tabler/icons-react';
import { ArtPanel } from '@/components/marketing/art-panel';
import { Btn, H2, Muted, Section, useReveal } from './primitives';

/** Closing call to action used at the bottom of every marketing page. */
export function CtaBand({ title = <>Start with 1,100 <br /><Muted>free credits.</Muted></>, lead = 'No card. No seats. Live in minutes.' }: {
  title?: React.ReactNode; lead?: React.ReactNode;
}) {
  const ref = useReveal<HTMLDivElement>();
  return (
    <Section>
      <div ref={ref} className="home-reveal">
        <div id="footer-sentinel" className="h-1 w-1 pointer-events-none" />
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <H2>{title}</H2>
            <p className="mt-4 text-lg leading-relaxed mb-8" style={{ color: 'var(--warm-muted)' }}>{lead}</p>
            <div className="flex flex-wrap gap-3 mb-6">
              <Btn to="/auth">Start free <ArrowRight className="size-3.5" /></Btn>
              <Link to="/helpdesk-cost-calculator" className="inline-flex items-center gap-1.5 px-4 py-2.5 text-sm" style={{ color: 'var(--warm-muted)' }}>Try the calculator</Link>
            </div>
            <div className="flex flex-wrap gap-x-5 gap-y-1.5 text-sm" style={{ color: 'var(--warm-muted)' }}>
              {['No credit card', 'Unlimited members', 'EU-hosted', 'No contract'].map((f) => (
                <span key={f} className="flex items-center gap-1.5"><IconCheck size={14} stroke={2.25} style={{ color: 'var(--warm-ok)' }} /> {f}</span>
              ))}
            </div>
          </div>
          <ArtPanel tint="cta" className="h-64 flex items-center justify-center">
            <div className="text-center">
              <p className="font-display font-light text-4xl mb-2" style={{ color: 'var(--warm-text)' }}>$0.10</p>
              <p className="text-sm" style={{ color: 'var(--warm-muted)' }}>per ticket · unlimited members</p>
            </div>
          </ArtPanel>
        </div>
      </div>
    </Section>
  );
}
